import { Redemption, RedemptionFragment } from '../redemption.types'

export const LinkOnlyRedemptionBlockFragment: RedemptionFragment = {
  name: 'linkOnlyRedemption',
  partialFragment: `
    ...on LinkOnlyRedemption {
      id
      blockType
      excludedPlatforms {
        ios
        android
        web
      }
    }
  `,
}

export const LinkOnlyRedemptionBlockType = 'linkOnlyRedemption'

export interface LinkOnlyRedemptionBlock extends Redemption {
  blockType: typeof LinkOnlyRedemptionBlockType
}
